export const catalogOptions = {
  title: {
    default: 'High1 Resort',
    ko: '하이원리조트',
  },
  langSet: ['ko', 'en', 'cn'],
  pageMap: ['Cover', 'Intro', 'Contents', 'Resort', 'Banquet', 'Ski', 'Hotel', 'Activity', 'Location', 'Last'],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  responsiveMode: true,
  breakpoint: 768,
};
